import { render, staticRenderFns } from "./RemoteUpgradeList.vue?vue&type=template&id=6368eb6c&scoped=true"
import script from "./RemoteUpgradeList.vue?vue&type=script&lang=js"
export * from "./RemoteUpgradeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368eb6c",
  null
  
)

export default component.exports